import React, { FC } from 'react';
import { Text, View } from 'react-native';
import BatchTimeLineTrack from '@v2/pages/batch/details/modules/batch/components/BatchTimeLineTrack/BatchTimeLineTrack';
import { useSelector } from 'react-redux';
import { selectSingleBatch } from '@reducers/batch';
import { ProductionBatchStatistics } from '@interfaces/search';
import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { machineStatus, machineStatusColorName, machineStatusName } from '@helpers';
import { BATCH_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { ContainerStyle } from '@interfaces/base';

interface BatchTimelineWithLegendsProps extends ContainerStyle, WithColor {}

const BatchTimelineWithLegends: FC<BatchTimelineWithLegendsProps> = ({ C, containerStyle }) => {
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);

  const { legendBulletSize, timelineHeight } = BATCH_BLOCK_CONFIG;

  return (
    <View style={[{ width: '100%', alignItems: 'center', gap: scale(12) }, containerStyle]}>
      <View style={{ width: '100%', height: scale(timelineHeight) }}>
        <BatchTimeLineTrack C={C} productionBatchId={batch?.productionBatchId} start={batch?.startedOn} withGaps={false} height={timelineHeight} />
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(6) }}>
        {Object.values(machineStatus).map((status) => (
          <View style={{ flexDirection: 'row', gap: scale(6), alignItems: 'center' }}>
            <View
              style={{
                width: scale(legendBulletSize),
                height: scale(legendBulletSize),
                borderRadius: scale(legendBulletSize) / 2,
                backgroundColor: C(machineStatusColorName[status]),
              }}
            />
            <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t(machineStatusName[status])}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default ColorWrapper(BatchTimelineWithLegends);
